<template>
  <div :class="$attrs.class">
    <router-link class="tw-cursor-pointer tw-group tw-w-full tw-block" :to="{ name: 'category', params: { id:  category.id}}">
      <div :class="['tw-uppercase', {'tw-font-black tw-border-l-4 tw-border-orange-medium tw-pl-2': isActive}]">
        {{category.name}}
      </div>
    </router-link>
  </div>
</template>

<script setup lang="ts">
  import { ref, onMounted, computed } from 'vue'
  import { useRoute } from 'vue-router';
  import type MenuCategory from '../../classes/MenuCategory';

  const props = defineProps<{ category: MenuCategory }>();

  const categoryImage = ref();
  const route = useRoute();

  onMounted(() => {
    
  })

  const isActive = computed(() => {
    return props.category.id == route.params.id
  })

</script>